<template>
  <dashboard-page title="Pesquisa de satisfação">
    <template #actions>
      <div class="d-flex align-items-center search-row">
        <div
          class="d-flex align-items-center w-100"
          style="
            padding: 7px;
            border: 0.5px solid rgb(218, 218, 218);
            border-radius: 5px;
            background-color: white;
            min-width: 25rem;
          "
        >
          <input
            class="search-input w-100"
            style="border: none"
            v-model="extraTopics"
            placeholder="tópicos adicionais (separados por vírgula)"
            @blur="onExtraTopicsBlur"
          />
        </div>
        <button
          type="button"
          class="btn-icon-outline ml-2 nps-open-responses-clear d-flex align-items-center justify-content-center px-2 text-muted"
          tabindex="-1"
          title="Incluir termos"
          aria-hidden="true"
        >
          <i class="fas fa-filter"></i>
        </button>
      </div>

      <div class="d-flex align-items-center nps-report-header-actions">
        <button
          type="button"
          class="btn-icon-outline nps-report-search-toggle search-row-mobile"
          :class="{ active: showSearchQuery }"
          @click="toggleSearchQuery"
          title="Tópicos adicionais"
        >
          <i class="fas fa-search"></i>
        </button>

        <!-- DROPDOWN MENU-->
        <b-row align-self="start" class="row-1 text-right mr-0 mb-0">
          <b-dropdown
            menu
            on
            right
            no-caret
            id="nps-report-menu"
            variant="secondary"
          >
            <template v-slot:button-content>
              <svg
                width="5"
                height="19"
                viewBox="0 0 5 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="2.19231" cy="2.19231" r="2.19231" fill="#12576e" />
                <circle cx="2.19231" cy="9.49992" r="2.19231" fill="#12576e" />
                <circle cx="2.19231" cy="16.8078" r="2.19231" fill="#12576e" />
              </svg>
            </template>

            <!-- <b-dropdown-item
              @click.prevent="loadNPSReport(true)"
              type="default"
            >
              <i class="no no-right-arrow"></i>exportar relatório
            </b-dropdown-item> -->
            <b-dropdown-item @click.prevent="openLegendPanel" type="default">
              <i class="no no-c-question-3"></i>como interpretar
            </b-dropdown-item>
          </b-dropdown>
        </b-row>
      </div>
    </template>

    <div
      class="d-flex align-items-center search-row-mobile px-3 mb-3"
      v-if="showSearchQuery"
    >
      <div
        class="d-flex align-items-center w-100"
        style="
          padding: 7px;
          border: 0.5px solid rgb(218, 218, 218);
          border-radius: 5px;
          background-color: white;
        "
      >
        <i class="fas fa-search mr-2" style="color: lightgrey"></i>
        <input
          class="search-input w-100"
          style="border: none"
          v-model="extraTopics"
          placeholder="Tópicos adicionais para análise (opcional)"
          @blur="onExtraTopicsBlur"
        />
      </div>
    </div>

    <base-header class="content__title content__title--calendar">
      <b-row align-v="center">
        <b-col class="m-0" cols="8">
          <span class="font-weight-normal text-primary text-center">
            <a
              href="#"
              :class="{ disabled: isLoading }"
              @click.prevent="prev"
              class="fullcalendar-btn-prev btn btn-sm btn-text py-1 vertical-middle mx-0"
            >
              <i
                class="no no-left-arrow font-size-lg text-primary vertical-middle"
              ></i>
            </a>

            <span
              class="booking-list-period-label font-weight-normal text-primary vertical-middle"
            >
              <span @click="openStartDatePicker">
                {{ periodStartDateLabel }}
              </span>
              <span> - </span>
              <span @click="openEndDatePicker">
                {{ periodEndDateLabel }}
              </span>
            </span>

            <date-picker
              ref="startDatePicker"
              v-model="startDate"
              @change="onDateChange"
              type="date"
              format="dd/MM/yy"
              value-format="yyyy-MM-dd"
              :clearable="false"
              class="booking-list-hidden-datepicker"
            />

            <date-picker
              ref="endDatePicker"
              v-model="endDate"
              @change="onDateChange"
              type="date"
              format="dd/MM/yy"
              value-format="yyyy-MM-dd"
              :clearable="false"
              class="booking-list-hidden-datepicker"
            />

            <a
              href="#"
              :class="{ disabled: isLoading }"
              @click.prevent="next"
              class="fullcalendar-btn-next btn btn-sm btn-text py-1 vertical-middle mx-0"
            >
              <i
                class="no no-right-arrow font-size-lg text-primary vertical-middle"
              ></i>
            </a>
          </span>
        </b-col>

        <b-col cols="4" class="m-0 text-right pl-0">
          <div
            v-if="!isMobileView"
            class="d-flex align-items-center justify-content-end w-100"
          >
            <div class="bg-pick">
              <button
                class="btn btn-letter"
                :class="{ active: defaultView === 'timeGridDay' }"
                @click="changeView('timeGridDay')"
              >
                Dia
              </button>
              <button
                class="btn btn-letter"
                :class="{ active: defaultView === 'dayGridWeek' }"
                @click="changeView('dayGridWeek')"
              >
                Semana
              </button>
              <button
                class="btn btn-letter"
                :class="{ active: defaultView === 'dayGridMonth' }"
                @click="changeView('dayGridMonth')"
              >
                Mês
              </button>
            </div>
          </div>
          <div
            v-else
            class="d-flex align-items-center justify-content-end w-100"
          >
            <b-form-select
              :value="defaultView"
              :options="viewModeOptions"
              class="booking-list-view-select"
              @change="changeView"
            />
          </div>
        </b-col>
      </b-row>

      <b-row align-v="center" class="mt-2">
        <b-col cols="12" md="5" lg="4" class="mb-2 mb-md-0">
          <b-form-select
            v-model="product_uuid"
            :options="productOptions"
            :disabled="isLoading || !productOptions.length"
            @change="loadNPSReport(false)"
            class="nps-product-select"
          />
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt-3 nps-report-body">
      <div v-if="isLoading" class="text-muted py-4">
        <i class="fas fa-spinner fa-spin mr-2"></i>carregando relatório...
      </div>

      <div v-else-if="!hasResults" class="text-muted py-4">
        Nenhum resultado encontrado no período.
      </div>

      <template v-else>
        <!-- Nota geral -->
        <b-row class="mb-4">
          <b-col cols="12" lg="5" class="mb-4 mb-lg-0">
            <b-card class="nps-section-card h-100" no-body>
              <b-card-header
                class="nps-section-header d-flex flex-column flex-md-row justify-content-between align-items-md-center"
              >
                <span>Nota geral da visitação</span>
                <span class="nps-section-hint">
                  Nível de Satisfação dos Clientes (CSAT - Customer Satisfaction
                  Score) representa o percentual de clientes satisfeitos
                </span>
              </b-card-header>

              <b-card-body v-if="official">
                <p class="nps-official-question mb-3">{{ official.title }}</p>

                <div class="d-flex align-items-end mb-1">
                  <span class="nps-official-value">
                    {{ formatPercent(official.csat) }}%
                  </span>
                  <span
                    class="nps-level-badge ml-3 mb-2"
                    :style="levelBadgeStyle(official.csatLevel)"
                  >
                    <i class="fas fa-circle mr-1"></i>
                    {{ levelLabel(official.csatLevel) }}
                  </span>
                </div>
                <p class="text-muted small mb-4">
                  CSAT: nota {{ scoreListLabel(official.positiveScores) }} em
                  <strong>{{ formatNumber(official.total) }}</strong> respostas na escala de 1 a
                  {{ official.scale }} 
                </p>

                <b-row class="mb-3">
                  <b-col cols="6">
                    <div class="nps-topic-metric-label">Cauda negativa</div>
                    <div class="nps-official-secondary text-danger">
                      {{ formatPercent(official.negativeShare) }}%
                      <small class="text-muted">
                        ({{ formatNumber(official.negative) }})
                      </small>
                    </div>
                  </b-col>
                  <b-col cols="6">
                    <div class="nps-topic-metric-label">Média</div>
                    <div class="nps-official-secondary">
                      {{ formatDecimal(official.average) }}
                      <small class="text-muted">/ {{ official.scale }}</small>
                    </div>
                  </b-col>
                </b-row>

                <div class="nps-distribution-bar">
                  <span
                    v-for="segment in distributionSegments(official)"
                    :key="'nota-' + segment.score"
                    :style="segment.style"
                    :title="segmentTitle(segment)"
                  ></span>
                </div>
                <div class="nps-distribution-legend">
                  <span
                    v-for="segment in distributionSegments(official)"
                    :key="'legenda-' + segment.score"
                  >
                    <i
                      class="fas fa-circle mr-1"
                      :style="{ color: segment.color }"
                    ></i>
                    {{ segment.score }} · {{ formatNumber(segment.count) }}
                  </span>
                </div>
              </b-card-body>
              <b-card-body v-else class="text-muted small">
                A pergunta principal (nps) não foi respondida no período.
              </b-card-body>
            </b-card>
          </b-col>

          <!-- Números chave -->
          <b-col cols="12" lg="7">
            <b-card class="nps-section-card h-100" no-body>
              <b-card-header
                class="nps-section-header d-flex flex-column flex-md-row justify-content-between align-items-md-center"
              >
                <span>Números-chave do período</span>
                <span class="nps-section-hint">
                  Funil do período: convites enviados, convites abertos, respostas e reembolsos
                </span>
              </b-card-header>
              <b-card-body>
                <b-row>
                  <b-col
                    v-for="item in keyNumberCards"
                    :key="item.key"
                    cols="6"
                    md="3"
                    class="mb-3"
                  >
                    <div
                      class="nps-key-number"
                      :style="{ borderColor: item.color }"
                    >
                      <div class="nps-key-number-label">
                        {{ item.label }}
                        <span
                          v-if="item.provisional"
                          class="nps-provisional-tag"
                        >
                          provisório
                        </span>
                      </div>
                      <div
                        class="nps-key-number-value"
                        :style="{ color: item.color }"
                      >
                        {{ formatNumber(item.value) }}
                      </div>
                      <div class="nps-key-number-hint">{{ item.hint }}</div>
                    </div>
                  </b-col>
                </b-row>

                <div class="nps-funnel mt-2">
                  <div
                    v-for="step in funnelSteps"
                    :key="step.key"
                    class="nps-funnel-step"
                  >
                    <div class="nps-funnel-track">
                      <span
                        class="nps-funnel-fill"
                        :style="{
                          width: step.width + '%',
                          background: step.color,
                        }"
                      ></span>
                    </div>
                    <div class="nps-funnel-caption">
                      <span>{{ step.label }}</span>
                      <span>
                        <strong>{{ formatNumber(step.value) }}</strong>
                        <small
                          v-if="step.rate !== null"
                          class="text-muted ml-1"
                        >
                          ({{ formatPercent(step.rate) }}% {{ step.rateLabel }})
                        </small>
                      </span>
                    </div>
                  </div>
                </div>

                <p class="text-muted small mb-0 mt-3">
                  *apenas reservas com telefone válido e com check-in confirmado
                  recebem o convite para responder a pesquisa.
                </p>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

        <!-- Respostas abertas -->
        <b-card
          v-if="sentiment.total"
          ref="openResponsesSection"
          class="mb-4 nps-section-card"
          no-body
        >
          <b-card-header
            class="nps-section-header d-flex flex-column flex-md-row justify-content-between align-items-left"
          >
            <span>Respostas abertas ({{ formatNumber(sentiment.total) }})</span>
            <span class="nps-section-hint">
              {{ formatPercent(openTextCoverage) }}% de quem respondeu comentou
              · cauda negativa das notas:
              {{ formatPercent(negativeTail.share) }}%
            </span>
          </b-card-header>
          <b-card-body>
            <p v-if="openTextQuestion" class="nps-official-question mb-3">
              {{ openTextQuestion.title }}
            </p>

            <b-row align-v="center" class="mb-3">
              <b-col cols="12" class="d-flex align-items-center">
                <div
                  class="d-flex align-items-center w-100 nps-open-responses-filter"
                >
                  <i class="fas fa-filter mr-2" style="color: lightgrey"></i>
                  <input
                    class="search-input w-100"
                    style="border: none"
                    v-model="openResponsesFilter"
                    placeholder="filtrar respostas (termos separados por vírgula)"
                  />
                </div>
                <button
                  type="button"
                  class="btn-icon-outline ml-2 nps-open-responses-clear d-flex align-items-center justify-content-center px-2 text-error btn-outline-danger"
                  :disabled="!openResponsesFilter"
                  title="Limpar filtro"
                  @click="clearOpenResponsesFilter"
                >
                  <i class="fas fa-times"></i>
                </button>
              </b-col>
            </b-row>
            <p
              v-if="openResponsesFilterTerms.length"
              class="text-muted small mb-3"
            >
              Mostrando respostas que contêm:
              <strong>{{ openResponsesFilterTerms.join(' · ') }}</strong>
            </p>

            <b-tabs
              ref="openResponsesTabs"
              v-model="openResponsesTab"
              content-class="mt-3"
              pills
              class="nps-response-tabs"
            >
              <b-tab
                v-for="tab in openResponseTabs"
                :key="tab.key"
                :title="openResponseTabTitle(tab)"
              >
                <div v-if="!tab.items.length" class="text-muted small">
                  Nenhuma resposta nesta categoria{{
                    openResponsesFilterTerms.length
                      ? ' com o filtro atual'
                      : ''
                  }}.
                </div>
                <p v-else class="text-muted small">{{ tab.hint }}</p>
                <div
                  v-for="(question, idx) in tab.items"
                  :key="tab.key + '-' + idx"
                  class="nps-open-response"
                  :style="{ borderLeftColor: tab.color }"
                >
                  {{ question }}
                </div>
              </b-tab>

              <b-tab title="Anaĺise por termo">
                <div v-if="!wordCloudEntries.length" class="text-muted small">
                  Sem dados suficientes.
                </div>
                <b-row v-else align-v="stretch">
                  <b-col cols="12" md="6" class="mb-3 mb-md-0">
                    <h6 class="nps-compare-subtitle mb-3">Principais termos</h6>
                    <apexchart
                      type="pie"
                      height="320"
                      :options="wordCloudChartOptions"
                      :series="wordCloudSeries"
                    />
                  </b-col>
                  <b-col cols="12" md="6">
                    <h6 class="nps-compare-subtitle mb-3">Nuvem de tags</h6>
                    <div class="nps-tag-cloud">
                      <span
                        v-for="item in wordCloudEntries"
                        :key="'tag-' + item.word"
                        class="nps-tag-cloud-item"
                        :style="wordCloudTagStyle(item)"
                        :title="`${item.word}: ${item.count} ocorrências`"
                      >
                        {{ item.word }}
                      </span>
                    </div>
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>
          </b-card-body>
        </b-card>

        <!-- Análise de sentimento -->
        <b-card v-if="sentiment.total" class="mb-4 nps-section-card" no-body>
          <b-card-header
            class="nps-section-header d-flex flex-column flex-md-row justify-content-between align-items-md-center"
          >
            <span>Análise de sentimento dos comentários</span>
            <span class="nps-section-hint">
              Polaridade dos textos livres (positivo, neutro, sugestão ou
              negativo)
            </span>
          </b-card-header>
          <b-card-body>
            <div class="nps-sentiment-score mb-4">
              <span class="nps-sentiment-score-value">
                {{ formatPercent(sentiment.sentimentScore) }}
              </span>
              <span
                class="nps-level-badge ml-2"
                :style="levelBadgeStyle(sentiment.sentimentScoreLevel)"
              >
                <i class="fas fa-circle mr-1"></i>
                {{ levelLabel(sentiment.sentimentScoreLevel) }}
              </span>
              <p class="text-muted small mt-2 mb-0">
                Índice de 0 a 100 calculado só pela polaridade dos comentários
                (positiva = 1, neutra ou mista = 0,5, negativa = 0)
              </p>
            </div>

            <b-row>
              <b-col
                v-for="item in sentimentBreakdown"
                :key="item.key"
                cols="6"
                md="4"
                lg="3"
                class="mb-3"
              >
                <div
                  class="nps-sentiment-metric"
                  :style="{ borderColor: item.color }"
                >
                  <div
                    class="nps-sentiment-metric-icon"
                    :style="{ color: item.color }"
                  >
                    <i :class="item.icon"></i>
                  </div>
                  <div>
                    <div class="nps-sentiment-metric-label">
                      {{ item.label }}
                    </div>
                    <div class="nps-sentiment-metric-value">
                      {{ formatPercent(item.value) }}%
                    </div>
                    <div class="nps-key-number-hint">
                      {{ formatNumber(item.count) }} comentários
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>

            <p class="text-muted small mb-0">
              Positivas, neutras e negativas somam 100%. Comentários mistos
              (elogio + crítica) entram em negativas para não esconder o
              problema relatado, e sugestões podem aparecer em qualquer
              polaridade.
            </p>
          </b-card-body>
        </b-card>

        <!-- Análise quantitativa -->
        <b-card class="mb-4 nps-section-card" no-body>
          <b-card-header
            class="nps-section-header d-flex flex-column flex-md-row justify-content-between align-items-left"
          >
            <span>Análise quantitativa</span>
            <span class="nps-section-hint">
              {{ questions.length }} perguntas respondidas no período
            </span>
          </b-card-header>
          <b-card-body class="p-0">
            <div class="table-responsive">
              <table
                class="table table-sm table-hover mb-0 nps-questions-table"
              >
                <thead>
                  <tr>
                    <th>Pergunta</th>
                    <th
                      v-for="score in scoreColumns"
                      :key="'col-' + score"
                      class="text-center"
                    >
                      {{ score }}
                    </th>
                    <th class="text-center">Total</th>
                    <th class="text-center">Média</th>
                    <th class="text-center">CSAT</th>
                    <th class="text-center">Insatisfação</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="group in questionsBySession">
                    <tr
                      v-if="group.session"
                      :key="'sessao-' + group.session"
                      class="nps-session-row"
                    >
                      <td :colspan="scoreColumns.length + 5">
                        {{ group.session }}
                      </td>
                    </tr>
                    <tr v-for="q in group.questions" :key="q.slug">
                      <td>
                        {{ q.title }}
                        <small class="text-muted d-block">
                          escala 1–{{ q.scale }}
                        </small>
                      </td>
                      <td
                        v-for="score in scoreColumns"
                        :key="q.slug + '-' + score"
                        class="text-center"
                        :class="{ 'text-muted': score > q.scale }"
                      >
                        {{ distributionLabel(q, score) }}
                      </td>
                      <td class="text-center">{{ formatNumber(q.total) }}</td>
                      <td class="text-center">
                        {{ formatDecimal(q.average) }}
                        <small class="text-muted">/{{ q.scale }}</small>
                      </td>
                      <td class="text-center">
                        <span
                          class="nps-level-badge"
                          :style="levelBadgeStyle(q.csatLevel)"
                        >
                          {{ formatPercent(q.csat) }}%
                        </span>
                      </td>
                      <td class="text-center">
                        <span :class="negativeShareClass(q)">
                          {{ formatPercent(q.negativeShare) }}%
                        </span>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </b-card-body>
        </b-card>

        <b-card class="mb-4 nps-section-card" no-body>
          <b-card-header
            class="nps-section-header d-flex flex-column flex-md-row justify-content-between align-items-left"
          >
            <span> Satisfação x insatisfação por pergunta </span>
            <span class="nps-section-hint">
              {{ questions.length }} perguntas respondidas no período
            </span>
          </b-card-header>
          <b-card-body class="p-0">
            <div v-if="questions.length > 1" class="p-3 border-top">
              <apexchart
                type="bar"
                :height="questionsChartHeight"
                :options="questionsChartOptions"
                :series="questionsChartSeries"
              />
            </div>
          </b-card-body>
        </b-card>

        <!-- Principais temas -->
        <b-row>
          <b-col cols="12" class="mb-4">
            <b-card class="nps-section-card h-100" no-body>
              <b-card-header
                class="nps-section-header d-flex flex-column flex-md-row justify-content-between align-items-md-center"
              >
                <span>Principais temas</span>
                <span class="nps-section-hint">
                  Assuntos mais citados e o impacto deles na satisfação
                </span>
              </b-card-header>
              <b-card-body>
                <div v-if="!mainTopicsList.length" class="text-muted small">
                  Sem temas identificados.
                </div>
                <div
                  v-for="topic in mainTopicsList"
                  :key="topic.key || topic.word"
                  class="nps-topic-card mb-3"
                  :class="{ 'nps-topic-card--custom': topic.custom }"
                >
                  <div class="nps-topic-title">
                    {{ topic.word }}
                    <span v-if="topic.custom" class="nps-provisional-tag ml-2">
                      tópico do gestor
                    </span>
                    <a
                      href="#"
                      class="nps-topic-citations-link ml-2"
                      :title="`Filtrar respostas abertas por “${topic.word}”`"
                      @click.prevent="addTopicToOpenResponsesFilter(topic)"
                    >
                      <i class="fas fa-filter mr-1"></i>
                      {{ formatNumber(topic.count) }} citações
                    </a>
                  </div>

                  <div class="nps-topic-metrics">
                    <div class="nps-topic-metric">
                      <span class="nps-topic-metric-label">Impacto</span>
                      <span
                        class="nps-level-badge"
                        :style="levelBadgeStyle(topic.impactScoreLevel)"
                      >
                        {{ formatPercent(topic.impactScore) }}% ·
                        {{ levelLabel(topic.impactScoreLevel) }}
                      </span>
                    </div>
                    <div class="nps-topic-metric">
                      <span class="nps-topic-metric-label">Confiança</span>
                      <span
                        class="nps-level-badge"
                        :style="levelBadgeStyle(topic.confidenceScoreLevel)"
                      >
                        {{ formatPercent(topic.confidenceScore) }}% ·
                        {{ levelLabel(topic.confidenceScoreLevel) }}
                      </span>
                    </div>
                    <div class="nps-topic-metric">
                      <span class="nps-topic-metric-label">Prioridade</span>
                      <span
                        class="nps-level-badge"
                        :style="levelBadgeStyle(topic.priorityScoreLevel)"
                      >
                        {{ formatPercent(topic.priorityScore) }}% ·
                        {{ levelLabel(topic.priorityScoreLevel) }}
                      </span>
                    </div>
                  </div>

                  <div class="nps-topic-sentiment">
                    <div class="d-flex align-items-center mb-2">
                      <span class="nps-topic-metric-label mb-0 mr-2"
                        >Sentimento</span
                      >
                      <span
                        class="nps-level-badge"
                        :style="levelBadgeStyle(topic.sentimentScoreLevel)"
                      >
                        {{ formatPercent(topic.sentimentScore) }} ·
                        {{ levelLabel(topic.sentimentScoreLevel) }}
                      </span>
                    </div>
                    <div class="nps-topic-sentiment-bars">
                      <span class="nps-mini-pill" style="color: #20824f">
                        <i class="far fa-smile mr-1"></i
                        >{{ formatPercent(topic.positive) }}%
                      </span>
                      <span class="nps-mini-pill" style="color: #6c757d">
                        <i class="far fa-meh mr-1"></i
                        >{{ formatPercent(topic.neutral) }}%
                      </span>
                      <span class="nps-mini-pill" style="color: #e67e22">
                        <i class="fas fa-lightbulb mr-1"></i
                        >{{ formatPercent(topic.sugestion) }}%
                      </span>
                      <span class="nps-mini-pill" style="color: #d93051">
                        <i class="far fa-frown mr-1"></i
                        >{{ formatPercent(topic.negative) }}%
                      </span>
                    </div>
                  </div>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </template>
    </b-container>

    <b-sidebar
      :visible="showLegendPanel"
      no-header-close
      right
      backdrop
      shadow
      width="480px"
      @change="onLegendSidebarChange"
    >
      <template #header>
        <b-row align-v="center" class="w-100 mt-2">
          <b-col cols="2">
            <button
              @click.prevent="closeLegendPanel"
              type="button"
              class="close"
              aria-label="Fechar"
            >
              <span class="no no-e-remove"></span>
            </button>
          </b-col>
        </b-row>
      </template>

      <div class="pr-4 pl-4 pb-5 nps-legend-panel">
        <h2 class="mb-3" style="color: #12576e">
          Legenda de Interpretação do Relatório
        </h2>

        <section class="mb-4">
          <h5 class="nps-legend-title">1. Nota geral</h5>
          <br />
          <p class="small text-muted">
            * <b>CSAT (Customer Satisfaction Score)</b>: Mede o nível de
            satisfação dos clientes com produtos, serviços ou atendimentos nos
            principais pontos de contato. Representa o percentual de clientes
            satisfeitos em relação ao total avaliado.
          </p>
        </section>

        <section class="mb-4">
          <h5 class="nps-legend-title">2. Números-chave</h5>
          <ul class="small">
            <li>
              <b>Receberam o convite</b> — pessoas para quem a pesquisa foi enviada
            </li>
            <li><b>Abriram a pesquisa</b> — visualizações do formulário</li>
            <li><b>Responderam</b> — respostas efetivamente registradas</li>
            <li><b>Reembolsos</b> — reembolsos feitos no período</li>
          </ul>
          <p class="small text-muted mb-0">
            A taxa de abertura compara aberturas com convites e a taxa de
            resposta compara respostas com aberturas. Enquanto a rota do
            relatório não devolver esses campos, eles aparecem marcados como
            provisórios.
          </p>
        </section>

        <section class="mb-4">
          <h5 class="nps-legend-title">3. Métricas das perguntas</h5>
          <p class="small text-muted">
            Cada pergunta usa a escala definida no próprio formulário: as
            perguntas de satisfação vão de 1 a 5 e as de disponibilidade de
            informação de 1 a 3 (Insuficiente, Adequada, Excelente). Por isso a
            média sempre aparece com a escala ao lado.
          </p>
          <ul class="small">
            <li>
              <b>CSAT</b> — notas do topo da escala (4 e 5, ou 3 na escala de 3)
            </li>
            <li>
              <b>Insatisfação</b> — cauda negativa, a base da escala (1 e 2, ou
              1)
            </li>
          </ul>

          <p class="small mb-1">
            <strong>Média (proporcional à escala)</strong>
          </p>
          <table class="table table-sm table-bordered nps-legend-table">
            <thead>
              <tr>
                <th>Faixa</th>
                <th>Avaliação</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>4.5 – 5.0</td>
                <td>Excelente</td>
              </tr>
              <tr>
                <td>4.0 – 4.49</td>
                <td>Boa</td>
              </tr>
              <tr>
                <td>3.0 – 3.99</td>
                <td>Regular</td>
              </tr>
              <tr>
                <td>&lt; 3.0</td>
                <td>Crítica</td>
              </tr>
            </tbody>
          </table>

          <p class="small mb-1"><strong>CSAT</strong></p>
          <table class="table table-sm table-bordered nps-legend-table">
            <thead>
              <tr>
                <th>Faixa</th>
                <th>Avaliação</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>≥ 90%</td>
                <td>Excelente</td>
              </tr>
              <tr>
                <td>75% – 89%</td>
                <td>Boa</td>
              </tr>
              <tr>
                <td>60% – 74%</td>
                <td>Regular</td>
              </tr>
              <tr>
                <td>&lt; 60%</td>
                <td>Baixa</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section class="mb-4">
          <h5 class="nps-legend-title">4. Análise de sentimento</h5>
          <ul class="small nps-legend-sentiment-list">
            <li>
              <i class="fas fa-lightbulb" style="color: #e67e22"></i>
              <b>Sugestões</b> — pedido de melhoria, em qualquer polaridade
            </li>
            <li>
              <i class="far fa-smile" style="color: #20824f"></i>
              <b>Positivas</b> — só elogios
            </li>
            <li>
              <i class="far fa-meh" style="color: #6c757d"></i>
              <b>Neutras</b> — sem elogio nem crítica
            </li>
            <li>
              <i class="far fa-frown" style="color: #d93051"></i>
              <b>Negativas</b> — críticas, incluindo comentários mistos
            </li>
          </ul>
          <p class="small text-muted">
            Polaridade e sugestão são dimensões independentes: um comentário que
            elogia e pede melhoria aparece nas duas listas. Assim uma sugestão
            deixa de ser arquivada como elogio e o índice de sentimento não é
            penalizado por ela.
          </p>

          <p class="small mb-1">
            <strong>Índice de sentimento (0 a 100)</strong>
          </p>
          <table class="table table-sm table-bordered nps-legend-table">
            <thead>
              <tr>
                <th>Faixa</th>
                <th>Avaliação</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>80 – 100</td>
                <td><span style="color: #146c43">●</span> Muito positivo</td>
              </tr>
              <tr>
                <td>60 – 79</td>
                <td><span style="color: #20824f">●</span> Positivo</td>
              </tr>
              <tr>
                <td>40 – 59</td>
                <td><span style="color: #e67e22">●</span> Neutro</td>
              </tr>
              <tr>
                <td>20 – 39</td>
                <td><span style="color: #d93051">●</span> Negativo</td>
              </tr>
              <tr>
                <td>0 – 19</td>
                <td><span style="color: #8b1a2b">●</span> Crítico</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section>
          <h5 class="nps-legend-title">5. Análise por tema</h5>
          <p class="small text-muted">
            Os temas padrão agrupam sinônimos (sinalização, placas e mapas
            contam juntos, por exemplo). Os tópicos digitados no campo de
            filtros são somados a esses temas, nunca substituem os padrão.
          </p>
          <p class="small mb-1">
            <strong>Impacto</strong> — citações do tema sobre o tema mais citado
          </p>
          <table class="table table-sm table-bordered nps-legend-table">
            <tbody>
              <tr>
                <td>80 – 100%</td>
                <td>Muito alto</td>
              </tr>
              <tr>
                <td>60 – 79%</td>
                <td>Alto</td>
              </tr>
              <tr>
                <td>40 – 59%</td>
                <td>Médio</td>
              </tr>
              <tr>
                <td>20 – 39%</td>
                <td>Baixo</td>
              </tr>
              <tr>
                <td>&lt; 20%</td>
                <td>Irrelevante/ruído</td>
              </tr>
            </tbody>
          </table>
          <p class="small mb-1">
            <strong>Confiança</strong> — citações do tema sobre o total de
            comentários
          </p>
          <p class="small mb-1">
            <strong>Prioridade</strong> — impacto x insatisfação do tema
          </p>
          <table class="table table-sm table-bordered nps-legend-table">
            <tbody>
              <tr>
                <td>≥ 60%</td>
                <td>Crítica</td>
              </tr>
              <tr>
                <td>40 – 59%</td>
                <td>Alta</td>
              </tr>
              <tr>
                <td>20 – 39%</td>
                <td>Média</td>
              </tr>
              <tr>
                <td>&lt; 20%</td>
                <td>Baixa</td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
    </b-sidebar>
  </dashboard-page>
</template>

<script>
import { DatePicker } from 'element-ui'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import { isMobile } from '../../store/utils/general'

const SENTIMENT_COLORS = {
  positive: '#20824f',
  neutral: '#6c757d',
  sugestion: '#e67e22',
  negative: '#d93051',
  mixed: '#8e6fa8',
}

const SCORE_COLORS = {
  1: '#d93051',
  2: '#e8815a',
  3: '#f5b041',
  4: '#5aa469',
  5: '#20824f',
}

const EMPTY_SENTIMENT = {
  positive: 0,
  neutral: 0,
  negative: 0,
  mixed: 0,
  sugestion: 0,
  positiveCount: 0,
  neutralCount: 0,
  negativeCount: 0,
  mixedCount: 0,
  sugestionCount: 0,
  sentimentScore: 0,
  total: 0,
  classifiedTexts: { positive: [], neutral: [], sugestion: [], negative: [] },
}

export default {
  name: 'NPSReport',

  components: {
    DatePicker,
    apexchart: VueApexCharts,
  },

  data() {
    return {
      isLoading: false,
      startDate: null,
      endDate: null,
      defaultView: 'dayGridMonth',
      isMobileView: isMobile(),
      showSearchQuery: false,
      viewModeOptions: [
        { value: 'timeGridDay', text: 'Dia' },
        { value: 'dayGridWeek', text: 'Semana' },
        { value: 'dayGridMonth', text: 'Mês' },
      ],
      extraTopics: '',
      lastLoadedExtraTopics: '',
      openResponsesFilter: '',
      showLegendPanel: false,
      openResponsesTab: 0,
      product_uuid: '',
      report: {},
    }
  },

  computed: {
    ...mapGetters('auth', {
      user: 'user',
      place: 'getPlace',
      params: 'params',
    }),

    ...mapGetters('product', {
      poisList: 'getPois',
    }),

    productOptions() {
      const options = (this.poisList || [])
        .filter((poi) => poi && poi.uuid)
        .map((poi) => ({
          value: poi.uuid,
          text:
            poi.product_name || poi.name || poi.product_place_name || poi.uuid,
        }))
        .sort((a, b) => String(a.text).localeCompare(String(b.text), 'pt-BR'))

      if (!options.length) {
        return [
          { value: '', text: 'Nenhum produto encontrado', disabled: true },
        ]
      }

      return [
        { value: '', text: 'Selecione um produto', disabled: true },
        ...options,
      ]
    },

    selectedProduct() {
      if (!this.product_uuid) return null
      return (
        (this.poisList || []).find((poi) => poi.uuid === this.product_uuid) ||
        null
      )
    },

    selectedProductName() {
      const product = this.selectedProduct
      if (!product) return ''
      return product.product_name || product.name || ''
    },

    periodStartDateLabel() {
      if (!this.startDate) return '--'
      const start = moment(this.startDate)
      return start.isValid() ? start.format('DD/MM/YY') : '--'
    },

    periodEndDateLabel() {
      if (!this.endDate) return '--'
      const end = moment(this.endDate)
      return end.isValid() ? end.format('DD/MM/YY') : '--'
    },

    questions() {
      const questions = (this.report && this.report.questions) || []
      return Array.isArray(questions) ? questions : []
    },

    hasResults() {
      return this.questions.length > 0 || !!this.report.total_responses
    },

    official() {
      return (this.report && this.report.official) || null
    },

    keyNumbers() {
      return (this.report && this.report.keyNumbers) || {}
    },

    negativeTail() {
      return (
        (this.report && this.report.negativeTail) || { share: 0, worst: [] }
      )
    },

    openTextQuestion() {
      return (this.report && this.report.openTextQuestion) || null
    },

    keyNumberCards() {
      const numbers = this.keyNumbers
      const visitors = numbers.visitors || { value: 0 }
      const opened = numbers.opened || { value: 0 }
      const answered = numbers.answered || { value: 0 }
      const refunded = numbers.refunded || { value: 0 }

      return [
        {
          key: 'visitors',
          label: 'Receberam o convite',
          value: visitors.value,
          provisional: visitors.provisional,
          color: '#12576e',
          hint: 'convites enviados',
        },
        {
          key: 'opened',
          label: 'Abriram a pesquisa',
          value: opened.value,
          provisional: opened.provisional,
          color: '#1f7a8c',
          hint: this.rateHint(numbers.openRate, 'dos convites'),
        },
        {
          key: 'answered',
          label: 'Responderam',
          value: answered.value,
          provisional: false,
          color: '#20824f',
          hint: this.rateHint(numbers.answerRate, 'de quem abriu'),
        },
        {
          key: 'refunded',
          label: 'Reembolsos',
          value: refunded.value,
          provisional: refunded.provisional,
          color: '#d93051',
          hint: 'no período',
        },
      ]
    },

    funnelSteps() {
      const numbers = this.keyNumbers
      const visitors = (numbers.visitors && numbers.visitors.value) || 0
      const opened = (numbers.opened && numbers.opened.value) || 0
      const answered = (numbers.answered && numbers.answered.value) || 0
      const base = visitors || opened || answered || 1

      return [
        {
          key: 'visitors',
          label: 'Receberam o convite',
          value: visitors,
          width: (visitors / base) * 100,
          color: '#12576e',
          rate: null,
          rateLabel: '',
        },
        {
          key: 'opened',
          label: 'Abriram a pesquisa',
          value: opened,
          width: (opened / base) * 100,
          color: '#1f7a8c',
          rate: numbers.openRate == undefined ? null : numbers.openRate,
          rateLabel: 'dos convites',
        },
        {
          key: 'answered',
          label: 'Responderam',
          value: answered,
          width: (answered / base) * 100,
          color: '#20824f',
          rate: numbers.coverage == undefined ? null : numbers.coverage,
          rateLabel: 'dos convites',
        },
      ]
    },

    scoreColumns() {
      const max = this.questions.reduce(
        (acc, question) => Math.max(acc, Number(question.scale) || 0),
        0
      )
      const columns = []
      for (let score = 1; score <= (max || 5); score++) columns.push(score)
      return columns
    },

    questionsBySession() {
      const groups = []

      this.questions.forEach((question) => {
        const session = question.session || ''
        const last = groups[groups.length - 1]

        if (last && last.session === session) {
          last.questions.push(question)
          return
        }

        groups.push({ session, questions: [question] })
      })

      return groups
    },

    questionsChartSeries() {
      return [
        {
          name: 'CSAT',
          data: this.questions.map((question) => Number(question.csat) || 0),
        },
        {
          name: 'Insatisfação',
          data: this.questions.map(
            (question) => Number(question.negativeShare) || 0
          ),
        },
      ]
    },

    questionsChartHeight() {
      return Math.max(220, this.questions.length * 46 + 80)
    },

    questionsChartOptions() {
      return {
        chart: { type: 'bar', toolbar: { show: false }, stacked: false },
        plotOptions: {
          bar: { horizontal: true, barHeight: '70%', borderRadius: 2 },
        },
        colors: [SENTIMENT_COLORS.positive, SENTIMENT_COLORS.negative],
        dataLabels: {
          enabled: true,
          formatter: (value) => `${Math.round(value)}%`,
          style: { fontSize: '11px' },
        },
        xaxis: {
          categories: this.questions.map((question) =>
            this.truncate(question.title, 34)
          ),
          max: 100,
          labels: { formatter: (value) => `${Math.round(value)}%` },
        },
        legend: { position: 'top' },
        tooltip: {
          y: { formatter: (value) => `${this.formatPercent(value)}%` },
        },
        grid: { borderColor: '#eef3f6' },
      }
    },

    sentiment() {
      const sentiment =
        this.report &&
        this.report.processedSuggestions &&
        this.report.processedSuggestions.sentiment

      return sentiment || EMPTY_SENTIMENT
    },

    openTextCoverage() {
      const answered = Number(this.report.total_responses) || 0
      if (!answered) return 0
      return (Number(this.sentiment.total || 0) / answered) * 100
    },

    sentimentBreakdown() {
      const s = this.sentiment

      return [
        {
          key: 'positive',
          label: 'Positivas',
          value: s.positive,
          count: s.positiveCount,
          color: SENTIMENT_COLORS.positive,
          icon: 'far fa-smile',
        },
        {
          key: 'neutral',
          label: 'Neutras',
          value: s.neutral,
          count: s.neutralCount,
          color: SENTIMENT_COLORS.neutral,
          icon: 'far fa-meh',
        },
        {
          key: 'negative',
          label: 'Negativas',
          value: s.negative,
          count: s.negativeCount,
          color: SENTIMENT_COLORS.negative,
          icon: 'far fa-frown',
        },
        {
          key: 'sugestion',
          label: 'Sugestões',
          value: s.sugestion,
          count: s.sugestionCount,
          color: SENTIMENT_COLORS.sugestion,
          icon: 'fas fa-lightbulb',
        },
        {
          key: 'mixed',
          label: 'Mistas (elogio + crítica)',
          value: s.mixed,
          count: s.mixedCount,
          color: SENTIMENT_COLORS.mixed,
          icon: 'fas fa-adjust',
        },
      ]
    },

    classifiedTexts() {
      const texts = this.sentiment.classifiedTexts || {}
      return {
        negative: Array.isArray(texts.negative) ? texts.negative : [],
        neutral: Array.isArray(texts.neutral) ? texts.neutral : [],
        positive: Array.isArray(texts.positive) ? texts.positive : [],
        sugestion: Array.isArray(texts.sugestion) ? texts.sugestion : [],
      }
    },

    openResponsesFilterTerms() {
      return this.parseOpenResponsesFilterTerms(this.openResponsesFilter)
    },

    openResponseTabs() {
      const texts = this.classifiedTexts
      const filterItems = (items) =>
        items.filter((text) => this.matchesOpenResponsesFilter(text))

      const buildTab = (key, label, color, allItems, hint) => {
        const items = filterItems(allItems)
        return {
          key,
          label,
          color,
          items,
          count: items.length,
          totalCount: allItems.length,
          hint,
        }
      }

      return [
        buildTab(
          'negative',
          'Negativas',
          SENTIMENT_COLORS.negative,
          texts.negative,
          'Críticas e comentários mistos, onde está a cauda negativa.'
        ),
        buildTab(
          'neutral',
          'Neutras',
          SENTIMENT_COLORS.neutral,
          texts.neutral,
          'Comentários sem elogio, crítica ou pedido de melhoria.'
        ),
        buildTab(
          'positive',
          'Positivas',
          SENTIMENT_COLORS.positive,
          texts.positive,
          'Elogios sem crítica associada.'
        ),
        buildTab(
          'sugestion',
          'Sugestões',
          SENTIMENT_COLORS.sugestion,
          texts.sugestion,
          'Pedidos de melhoria, em qualquer polaridade (positiva, neutra ou negativa).'
        ),
      ]
    },

    mainTopicsList() {
      const topics =
        (this.report &&
          this.report.processedSuggestions &&
          this.report.processedSuggestions.mainTopics) ||
        []
      return Array.isArray(topics) ? topics : []
    },

    wordCloudEntries() {
      const cloud =
        (this.report &&
          this.report.processedSuggestions &&
          this.report.processedSuggestions.wordCloud) ||
        []
      return Array.isArray(cloud) ? cloud.slice(0, 12) : []
    },

    wordCloudSeries() {
      return this.wordCloudEntries.map((item) => Number(item.count) || 0)
    },

    wordCloudChartOptions() {
      return {
        labels: this.wordCloudEntries.map((item) => item.word),
        legend: {
          position: 'bottom',
          fontSize: '12px',
        },
        chart: {
          type: 'pie',
          toolbar: { show: false },
        },
        dataLabels: {
          enabled: true,
          formatter(val) {
            return `${Math.round(val)}%`
          },
        },
        tooltip: {
          y: {
            formatter(value) {
              return `${value} ocorrências`
            },
          },
        },
        colors: [
          '#12576e',
          '#1A6884',
          '#20824f',
          '#e67e22',
          '#d93051',
          '#6c757d',
          '#5dade2',
          '#58d68d',
          '#f5b041',
          '#af7ac5',
          '#48c9b0',
          '#85929e',
        ],
      }
    },
  },

  watch: {
    openResponsesTab() {
      this.$nextTick(() => this.scrollActiveResponseTabIntoView())
    },

    hasResults(value) {
      if (!value) return
      this.$nextTick(() => {
        this.scrollActiveResponseTabIntoView()
        setTimeout(() => this.scrollActiveResponseTabIntoView(), 150)
      })
    },
  },

  async mounted() {
    this.changeView(this.defaultView, { silent: true })
    await this.loadProducts()
    await this.loadNPSReport(false)
    this.$nextTick(() => {
      this.scrollActiveResponseTabIntoView()
      setTimeout(() => this.scrollActiveResponseTabIntoView(), 150)
    })
  },

  methods: {
    ...mapActions('report', ['generateNPSReport', 'clearReportCacheFlags']),
    ...mapActions('product', ['fetchPOIs']),

    async loadProducts() {
      const placeUuid =
        (this.place && (this.place.uuid || this.place.janooUserUuid)) || ''

      if (!placeUuid) {
        this.product_uuid = ''
        return
      }

      try {
        await this.fetchPOIs({ PLACE_UUID: placeUuid, PRODUCT_UUID: '' })
        if (!this.product_uuid) {
          const filteredOptions = this.productOptions.filter(
            (option) => option.value && !option.disabled
          )
          const lastOption = filteredOptions[filteredOptions.length - 1]
          if (lastOption) {
            this.product_uuid = lastOption.value
          }
        }
      } catch (error) {
        console.error('Erro ao carregar produtos do relatório NPS:', error)
        this.product_uuid = ''
      }
    },

    normalizeFilterText(text) {
      return String(text || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
    },

    parseOpenResponsesFilterTerms(filter) {
      const terms = String(filter || '')
        .split(',')
        .map((term) => term.trim())
        .filter((term) => term.length > 0)

      const expanded = []
      const seen = new Set()

      terms.forEach((term) => {
        this.getSingularPluralFilterVariants(term).forEach((variant) => {
          const key = this.normalizeFilterText(variant)
          if (!key || seen.has(key)) return
          seen.add(key)
          expanded.push(variant)
        })
      })

      return expanded
    },

    getSingularPluralFilterVariants(term) {
      const value = String(term || '').trim()
      if (!value) return []

      const lower = value.toLowerCase()
      const variants = [value]

      if (lower.endsWith('s') && value.length > 1) {
        variants.push(value.slice(0, -1))
      } else {
        variants.push(`${value}s`)
      }

      return variants
    },

    matchesOpenResponsesFilter(text) {
      const terms = this.openResponsesFilterTerms
      if (!terms.length) return true

      const normalizedText = this.normalizeFilterText(text)

      return terms.some((term) => {
        const normalizedTerm = this.normalizeFilterText(term)
        if (!normalizedTerm) return false
        if (normalizedText.includes(normalizedTerm)) return true

        // Títulos compostos (ex.: "Limpeza e lixo"): casa se qualquer palavra
        // significativa do termo aparecer no comentário.
        const words = normalizedTerm
          .split(/\s+/)
          .filter((word) => word.length >= 4)

        return (
          words.length > 0 &&
          words.some((word) => normalizedText.includes(word))
        )
      })
    },

    clearOpenResponsesFilter() {
      this.openResponsesFilter = ''
    },

    openResponseTabTitle(tab) {
      if (!tab) return ''
      if (this.openResponsesFilterTerms.length) {
        return `${tab.label} (${tab.count}/${tab.totalCount})`
      }
      return `${tab.label} (${tab.count})`
    },

    addTopicToOpenResponsesFilter(topic) {
      const term = String((topic && topic.word) || '').trim()
      if (!term) return

      const currentTerms = String(this.openResponsesFilter || '')
        .split(',')
        .map((item) => item.trim())
        .filter((item) => item.length > 0)

      const alreadyAdded = currentTerms.some((existing) => {
        const existingKey = this.normalizeFilterText(existing)
        return this.getSingularPluralFilterVariants(term).some(
          (variant) => this.normalizeFilterText(variant) === existingKey
        )
      })

      if (!alreadyAdded) {
        this.openResponsesFilter = currentTerms.length
          ? `${currentTerms.join(', ')}, ${term}`
          : term
      }

      this.openResponsesTab = 0
      this.$nextTick(() => {
        this.scrollActiveResponseTabIntoView()
        const section = this.$refs.openResponsesSection
        const el = section && (section.$el || section)
        if (el && typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      })
    },

    distributionLabel(question, score) {
      if (score > question.scale) return '—'
      const value = question.distribution[score]
      return this.formatNumber(Number(value) || 0)
    },

    distributionSegments(question) {
      if (!question || !question.total) return []

      return Object.keys(question.distribution).map((score) => {
        const count = Number(question.distribution[score]) || 0
        const share = (count / question.total) * 100
        const color = SCORE_COLORS[score] || '#12576e'

        return {
          score,
          count,
          share,
          color,
          style: { width: `${share}%`, background: color },
        }
      })
    },

    segmentTitle(segment) {
      return `Nota ${segment.score}: ${
        segment.count
      } respostas (${this.formatPercent(segment.share)}%)`
    },

    scoreListLabel(scores) {
      if (!Array.isArray(scores) || !scores.length) return '--'
      return scores.join(' e ')
    },

    negativeShareClass(question) {
      if (question.negativeShare >= 15) return 'text-danger font-weight-bold'
      if (question.negativeShare >= 5) return 'text-warning font-weight-bold'
      return 'text-muted'
    },

    rateHint(rate, suffix) {
      if (rate == undefined || rate === null) return suffix
      return `${this.formatPercent(rate)}% ${suffix}`
    },

    truncate(text, size) {
      const value = String(text || '')
      return value.length > size ? `${value.slice(0, size - 1)}…` : value
    },

    formatNumber(value) {
      return Number(value || 0).toLocaleString('pt-BR')
    },

    formatDecimal(value) {
      return Number(value || 0)
        .toFixed(2)
        .replace('.', ',')
    },

    formatPercent(value) {
      return Number(value || 0)
        .toFixed(2)
        .replace('.', ',')
    },

    levelLabel(level) {
      return (level && level.label) || '--'
    },

    levelBadgeStyle(level) {
      const color = (level && level.color) || '#6c757d'
      return {
        color,
        borderColor: color,
        backgroundColor: 'rgba(0,0,0,0.03)',
      }
    },

    wordCloudTagStyle(item) {
      const counts = this.wordCloudEntries.map(
        (entry) => Number(entry.count) || 0
      )
      const max = Math.max(...counts, 1)
      const min = Math.min(...counts, 1)
      const count = Number(item.count) || 1
      const ratio = max === min ? 1 : (count - min) / (max - min)
      const fontSize = 0.85 + ratio * 1.35
      const colors = this.wordCloudChartOptions.colors || []
      const index = this.wordCloudEntries.findIndex(
        (entry) => entry.word === item.word
      )
      const color = colors[index % colors.length] || '#12576e'

      return {
        fontSize: `${fontSize}rem`,
        color,
        opacity: 0.7 + ratio * 0.3,
      }
    },

    openStartDatePicker() {
      const picker = this.$refs.startDatePicker
      if (!picker) return
      if (typeof picker.focus === 'function') picker.focus()
      picker.pickerVisible = true
    },

    openEndDatePicker() {
      const picker = this.$refs.endDatePicker
      if (!picker) return
      if (typeof picker.focus === 'function') picker.focus()
      picker.pickerVisible = true
    },

    toggleSearchQuery() {
      this.showSearchQuery = !this.showSearchQuery
    },

    async onDateChange() {
      this.fixDates()
      await this.loadNPSReport(false)
    },

    async onExtraTopicsBlur() {
      if (this.extraTopics === this.lastLoadedExtraTopics) return
      await this.loadNPSReport(false)
    },

    changeView(view, options = {}) {
      this.defaultView = view
      switch (view) {
        case 'timeGridDay':
          this.startDate = moment().format('YYYY-MM-DD')
          this.endDate = moment().format('YYYY-MM-DD')
          break
        case 'dayGridWeek':
          this.startDate = moment().startOf('week').format('YYYY-MM-DD')
          this.endDate = moment(this.startDate)
            .endOf('week')
            .format('YYYY-MM-DD')
          break
        case 'dayGridMonth':
        default:
          this.startDate = moment().startOf('month').format('YYYY-MM-DD')
          this.endDate = moment().endOf('month').format('YYYY-MM-DD')
          break
      }
      if (!options.silent) {
        this.loadNPSReport(false)
      }
    },

    prev() {
      const unit =
        this.defaultView === 'dayGridWeek'
          ? 'week'
          : this.defaultView === 'dayGridMonth'
          ? 'month'
          : 'day'
      this.startDate = moment(this.startDate)
        .subtract(1, unit)
        .format('YYYY-MM-DD')
      this.endDate = moment(this.endDate).subtract(1, unit).format('YYYY-MM-DD')
      this.loadNPSReport(false)
    },

    next() {
      const unit =
        this.defaultView === 'dayGridWeek'
          ? 'week'
          : this.defaultView === 'dayGridMonth'
          ? 'month'
          : 'day'
      this.startDate = moment(this.startDate).add(1, unit).format('YYYY-MM-DD')
      this.endDate = moment(this.endDate).add(1, unit).format('YYYY-MM-DD')
      this.loadNPSReport(false)
    },

    fixDates() {
      if (!this.startDate) {
        this.startDate = moment().startOf('month').format('YYYY-MM-DD')
      }
      // this.startDate = '2026-01-01'
      if (!this.endDate) {
        this.endDate = moment().endOf('month').format('YYYY-MM-DD')
      }
      // this.endDate = '2026-01-31'
      if (moment(this.startDate).isAfter(moment(this.endDate))) {
        const tmp = this.startDate
        this.startDate = this.endDate
        this.endDate = tmp
      }
    },

    async loadNPSReport(sendMail) {
      this.fixDates()

      if (!this.product_uuid) {
        this.report = {}
        return
      }

      this.isLoading = true
      this.openResponsesTab = 0

      const payload = {
        startDate: this.startDate,
        endDate: this.endDate,
        product_uuid: this.product_uuid,
        place: this.selectedProductName,
        place_uuid: this.place.uuid,
        extraTopics: this.extraTopics,
        vendor_email: '',
      }

      if (sendMail === true) {
        payload.vendor_email = this.user.email || this.place.email || ''
      }

      try {
        this.report = await this.generateNPSReport(payload)
        this.lastLoadedExtraTopics = this.extraTopics
        this.$nextTick(() => {
          this.scrollActiveResponseTabIntoView()
          setTimeout(() => this.scrollActiveResponseTabIntoView(), 150)
        })
      } finally {
        this.isLoading = false
      }
    },

    openLegendPanel() {
      this.showLegendPanel = true
    },

    closeLegendPanel() {
      this.showLegendPanel = false
    },

    onLegendSidebarChange(visible) {
      if (!visible) this.closeLegendPanel()
    },

    scrollActiveResponseTabIntoView() {
      const root =
        (this.$refs.openResponsesTabs && this.$refs.openResponsesTabs.$el) ||
        null
      if (!root || !root.querySelector) return

      const scrollEl = root.querySelector('.nav-pills')
      const activeEl = root.querySelector('.nav-link.active')
      if (!scrollEl || !activeEl) return

      const scrollRect = scrollEl.getBoundingClientRect()
      const activeRect = activeEl.getBoundingClientRect()
      const padding = 12
      let nextLeft = scrollEl.scrollLeft

      if (activeRect.left < scrollRect.left + padding) {
        nextLeft -= scrollRect.left + padding - activeRect.left
      } else if (activeRect.right > scrollRect.right - padding) {
        nextLeft += activeRect.right - (scrollRect.right - padding)
      } else {
        return
      }

      if (typeof scrollEl.scrollTo === 'function') {
        scrollEl.scrollTo({ left: Math.max(0, nextLeft), behavior: 'smooth' })
      } else {
        scrollEl.scrollLeft = Math.max(0, nextLeft)
      }
    },
  },
}

/***
 * 
      collector_id: 'NM0uip',
      collectorIDs: {
        '4XCUO9': {
          label: 'Baixio',
          uuid: '2F2BCB3C-A778-11EB-9702-5254006CC309',
        },
        SND4nS: {
          label: 'Cachoeira do Buracão',
          uuid: '2F249056-A778-11EB-9702-5254006CC309',
        },
        A0D4w3: {
          label: 'Museu do Garimpo',
          uuid: '481E9F40-4B07-11ED-8534-F23C9227EC8D',
        },
        NM0uip: {
          label: 'Parque Da Muritiba',
          uuid: '5662C894-ABAE-11EC-8BF6-F23C9227EC8D',
        },
        xkD47D: {
          label: 'Parque Sempre Viva',
          uuid: '481E9F40-4B07-11ED-8534-F23C9227EC8D',
        },
      },
 */
</script>

<style>
.nps-report-body {
  padding-bottom: 2rem;
}

.nps-section-card {
  border: 1px solid #e6eef2;
  border-radius: 0.75rem;
  box-shadow: none;
}

.nps-section-header {
  background: #e6eef2;
  border-bottom: 1px solid #e6eef2;
  color: #12576e;
  font-weight: 600;
  font-size: 1rem;
}

.nps-section-hint {
  font-size: 0.75rem;
  font-weight: 400;
  color: #6c757d;
}

.nps-official-question {
  color: #24333d;
  font-weight: 600;
  font-size: 0.95rem;
  margin-bottom: 0;
}

.nps-official-value {
  font-size: 3rem;
  line-height: 1;
  font-weight: 600;
  color: #12576e;
}

.nps-official-secondary {
  font-size: 1.25rem;
  font-weight: 600;
  color: #24333d;
}

.nps-distribution-bar {
  display: flex;
  width: 100%;
  height: 14px;
  border-radius: 999px;
  overflow: hidden;
  background: #eef3f6;
}

.nps-distribution-bar span {
  display: block;
  height: 100%;
}

.nps-distribution-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem 0.85rem;
  margin-top: 0.5rem;
  font-size: 0.75rem;
  color: #6c757d;
}

.nps-key-number {
  border-left: 3px solid;
  background: #f8fafb;
  border-radius: 0.5rem;
  padding: 0.75rem 0.9rem;
  height: 100%;
}

.nps-key-number-label {
  font-size: 0.75rem;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  font-weight: 600;
}

.nps-key-number-value {
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 1.2;
}

.nps-key-number-hint {
  font-size: 0.72rem;
  color: #7a8790;
}

.nps-provisional-tag {
  display: inline-block;
  background: #fdf1dc;
  color: #b06f16;
  border-radius: 999px;
  padding: 0 0.4rem;
  font-size: 0.65rem;
  text-transform: none;
  letter-spacing: 0;
}

.nps-funnel-step + .nps-funnel-step {
  margin-top: 0.6rem;
}

.nps-funnel-track {
  background: #eef3f6;
  border-radius: 999px;
  height: 10px;
  overflow: hidden;
}

.nps-funnel-fill {
  display: block;
  height: 100%;
  border-radius: 999px;
}

.nps-funnel-caption {
  display: flex;
  justify-content: space-between;
  font-size: 0.78rem;
  color: #5a6a75;
  margin-top: 0.2rem;
}

.nps-questions-table th {
  white-space: nowrap;
  font-size: 0.8rem;
  color: #5a6a75;
}

.nps-questions-table td {
  font-size: 0.875rem;
  vertical-align: middle;
}

.nps-session-row td {
  background: #f7fafc;
  color: #12576e;
  font-weight: 600;
  font-size: 0.78rem !important;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.nps-sentiment-score-value {
  font-size: 2rem;
  font-weight: 600;
  color: #12576e;
}

.nps-level-badge {
  display: inline-flex;
  align-items: center;
  border: 1px solid;
  border-radius: 999px;
  padding: 0.15rem 0.55rem;
  font-size: 0.75rem;
  font-weight: 600;
}

.nps-sentiment-metric {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border-left: 3px solid;
  background: #f8fafb;
  border-radius: 0.5rem;
  padding: 0.75rem 0.9rem;
  min-height: 72px;
}

.nps-sentiment-metric-icon {
  font-size: 1.35rem;
}

.nps-sentiment-metric-label {
  font-size: 0.8rem;
  color: #6c757d;
}

.nps-sentiment-metric-value {
  font-size: 1.15rem;
  font-weight: 600;
  color: #24333d;
}

.nps-open-response {
  display: block;
  border-radius: 0.35rem;
  font-size: 0.85rem;
  padding: 0.55rem 0.75rem;
  margin: 0.5rem 0;
  background: #f8fafb;
  border-left: 3px solid;
}

.nps-compare-subtitle {
  color: #12576e;
  font-weight: 600;
  font-size: 0.9rem;
}

.nps-tag-cloud {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.65rem 0.85rem;
  min-height: 280px;
  padding: 1rem;
  background: #f8fafb;
  border-radius: 0.65rem;
  border: 1px solid #e6eef2;
}

.nps-tag-cloud-item {
  display: inline-block;
  font-weight: 600;
  line-height: 1.2;
  cursor: default;
  user-select: none;
  transition: transform 0.15s ease;
}

.nps-tag-cloud-item:hover {
  transform: scale(1.06);
}

.nps-topic-card {
  border: 1px solid #e6eef2;
  border-radius: 0.65rem;
  padding: 0.9rem 1rem;
  background: #fff;
}

.nps-topic-card--custom {
  border-color: #b7d4de;
  border-left: 3px solid #12576e;
  background: #f0f7fa;
}

.nps-topic-title {
  font-weight: 600;
  color: #12576e;
  margin-bottom: 0.75rem;
  text-transform: capitalize;
}

.nps-topic-citations-link {
  display: inline-flex;
  align-items: center;
  font-size: 0.8rem;
  font-weight: 600;
  color: #1f7a8c;
  text-decoration: none;
  text-transform: none;
  border-bottom: 1px dashed #7eb6c4;
}

.nps-topic-citations-link:hover {
  color: #12576e;
  border-bottom-color: #12576e;
  text-decoration: none;
}

.nps-topic-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.5rem;
  margin-bottom: 0.85rem;
}

.nps-topic-metric {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.nps-topic-metric-label {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: #7a8790;
  font-weight: 600;
}

.nps-topic-sentiment {
  border-top: 1px dashed #d9e3e8;
  padding-top: 0.75rem;
}

.nps-topic-sentiment-bars {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 0.85rem;
}

.nps-mini-pill {
  font-size: 0.8rem;
  font-weight: 600;
}

.nps-legend-title {
  color: #12576e;
  font-weight: 600;
}

.nps-legend-table {
  font-size: 0.8rem;
}

.nps-legend-sentiment-list {
  list-style: none;
  padding-left: 0;
}

.nps-legend-sentiment-list li {
  margin-bottom: 0.35rem;
}

.nps-product-select {
  max-width: 100%;
}

.nps-report-header-actions {
  gap: 0.35rem;
}

.nps-report-search-toggle {
  color: #12576e;
  background: transparent;
  cursor: pointer;
}

.nps-report-search-toggle.active {
  background-color: #e8f4f8;
}

.nps-extra-topics-hint {
  cursor: default;
  pointer-events: none;
}

.nps-open-responses-filter {
  padding: 7px;
  border: 0.5px solid rgb(218, 218, 218);
  border-radius: 5px;
  background-color: white;
}

.nps-open-responses-clear:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.booking-list-view-select {
  max-width: 140px;
  margin-left: auto;
}

.bg-pick {
  background-color: white;
  height: 25px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-right: 10px;
  margin-left: 10px;
  border-radius: 4px;
}

.btn-letter.active {
  background: #12576e;
  color: #fff;
}

.booking-list-period-label {
  cursor: pointer;
  user-select: none;
}

.booking-list-period-label span:hover {
  text-decoration: underline;
}

.booking-list-hidden-datepicker {
  position: absolute !important;
  width: 0 !important;
  height: 0 !important;
  min-width: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  opacity: 0 !important;
  overflow: hidden !important;
  pointer-events: none !important;
}

.booking-list-hidden-datepicker .el-input__inner {
  padding: 0 !important;
  height: 0 !important;
  line-height: 0 !important;
  border: none !important;
}

.booking-list-search-input fieldset {
  margin-bottom: 0 !important;
}

@media (max-width: 767.98px) {
  .nps-topic-metrics {
    grid-template-columns: 1fr;
  }

  .nps-response-tabs .nav-pills {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-x: contain;
    touch-action: pan-x;
    scrollbar-width: none;
    gap: 0.35rem;
    padding-bottom: 0.15rem;
  }

  .nps-response-tabs .nav-pills::-webkit-scrollbar {
    display: none;
  }

  .nps-response-tabs .nav-item {
    flex-shrink: 0;
  }

  .nps-response-tabs .nav-link {
    white-space: nowrap;
  }
}
</style>
